// Module
var code = "<div class=\"tw-shadow tw-bg-primary-l1 sm:tw-rounded tw-py-5\">\n    <div class=\"{{ ::$ctrl.titleClass }}\" data-ng-transclude=\"title\"></div>\n    <div class=\"{{ ::$ctrl.contentClass }}\" data-ng-transclude=\"content\"></div>\n</div>";
// Exports
module.exports = code;